// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_BqThU","inner":"_11xWbUb"};